import React from "react";
import capitalize from "../../../Utils/capitalize";

const ItemBody24 = ({ notification }) => {
  const total = Number(notification?.metaData?.quantity || 0);

  return (
    <div className="min-h-20">
      <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium">
          {total === 1 ? `${total} rental` : `${total} rentals`}
        </span>{" "}
        {total === 1 ? "was" : "were"} added in{" "}
        <span className="font-medium">
          {capitalize(notification?.metaData?.driverFirstName || "driver")}’s
          wallet.
        </span>
      </p>
    </div>
  );
};

export default ItemBody24;
